export default "__VITE_PUBLIC_ASSET__1d264783__"